import { memo } from "react";
import { OfferWidgetProps } from "./types";
import { useTranslate } from "helpers";
import { Tabs } from "ui/components/Tabs";
import OfferStatsTab from "./components/OfferStatsTab/OfferStatsTab";
import OfferSaleSearchTab from "./components/OfferSearchTab/OfferSaleSearchTab";
import OfferRentSearchTab from "./components/OfferSearchTab/OfferRentSearchTab";

const OfferWidget: React.FC<OfferWidgetProps> = () => {
  const { t } = useTranslate();

  return (
    <Tabs
      tabs={[
        {
          label: t("admin.dashboard.widget.offers.tab.stats.title"),
          content: <OfferStatsTab />,
        },
        {
          label: t("admin.dashboard.widget.offers.tab.search.sale.title"),
          content: <OfferSaleSearchTab />,
        },
        {
          label: t("admin.dashboard.widget.offers.tab.search.rent.title"),
          content: <OfferRentSearchTab />,
        },
      ]}
    />
  );
};

export default memo(OfferWidget);
